//
// AuthDelegate.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import EventDispatcher from "../../events/EventDispatcher";
import "../../lib";

var AuthDelegate = createModule("commons::AuthDelegate", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        extractAuthorizations: [0,1],
        injectAuthorizations: [0,1],
    },
    ,
    ,
]);
export default AuthDelegate;
